export const Stamp = ({ children, className = "" }) => (
  <span
    className={`stamp inline-block border-[3px] border-current px-3 py-1 font-display text-sm tracking-[0.2em] uppercase ${className}`}
  >
    {children}
  </span>
);
